<template>
  <!-- 应用设计页面 -->
  <div>
    <div class="td-header">
      <div
        v-if="$store.getters.appInfo"
        class="tdh-left"
      >
        <span class="tdhl-rect-icon" />
        <span
          class="tdhl-title"
          @click="goWorkbench"
        >应用中心</span>
        <span class="su-icon-arrow tdhl-arrow-icon" />
        <span class="tdhl-subtitle">{{ $store.getters.appInfo.ff_name }}</span>
      </div>
      <span
        class="tdh-right"
        @click="goWorkbench"
      >返回</span>
    </div>
    <el-container class="appflow">
      <div class="appflow-left">
        <div
          v-if="$store.getters.appInfo"
          class="afl-header"
        >
          <div
            :title="$store.getters.appInfo.ff_name"
            class="afl-title "
          >
            <span class="aflt-text">{{ $store.getters.appInfo.ff_name }}</span>
            <!-- <span class="su-icon-arrow" /> -->
          </div>
          <div class="afl-search" />
        </div>
        <router-link
          v-for="(item,index) in tabData"
          :to="{path: item.path, query: {form_id: $route.query.form_id, yyid: $route.query.yyid}}"
          :key="index"
          :class="{'af-item': true, 'af-item-active': $route.name === item.path}"
          tag="div"
          @click="toggleTab(item)"
        >
          <i
            :class="item.icon"
            class="afi-icon"
          />
          <span style="margin-top: 8px;">{{ item.title }}</span>
        </router-link>
      </div>
      <el-main>
        <router-view />
      </el-main>
    </el-container>
  </div>

</template>
<script>
import service from '@/utils/service'
import '../css/appflow/index.scss'
// import AFHeader from './components/header'
// const AFHeader = require('./components/header')
export default {
  // components: {
  //   AFHeader
  // },
  data () {
    return {
      tabData: [
        {
          title: '管理端',
          icon: 'su-icon-guanliduan',
          path: 'management'
        },
        {
          title: '设计端',
          icon: 'su-icon-shejiduan',
          path: 'design'
        }
      ],
      appInfo: {}
    }
  },
  beforeRouteUpdate (to, from, next) {
    this.aflsFlag = false
    if (to.params.fid !== from.params.fid) {
      this.getData(to.params.fid, to.query.form_id)
    }

    next()
  },
  created () {
    if (localStorage.getItem('appHisList')) {
      this.$store.commit('SET_HISLIST', JSON.parse(localStorage.getItem('appHisList')))
    }

    this.getData(this.$route.params.fid, this.$route.query.form_id)
  },
  mounted () {

  },
  methods: {
    goWorkbench () {
      sessionStorage.setItem('workbenchCache', JSON.stringify({ roleid: this.$route.query.roleid, groupid: this.$route.query.groupid }))
      this.$router.push({ path: '/workbench' })
    },
    getData (fid, formId) {
      service.get('/v1/application/getInfoByFid', {
        params: {
          fid: fid
        }
      }).then(res => {
        this.$store.commit('SET_APPINFO', res.data)
        this.handleBrowsingHistory({ ff_name: res.data.ff_name, fid: this.$route.params.fid, form_id: formId, time: Date.now() })
      }).catch(error => {
        this.$swMessage.error(error)
      })
    },
    handleBrowsingHistory (item) {
      var hisArr
      hisArr = JSON.parse(JSON.stringify(this.$store.getters.hisList))
      if (hisArr && hisArr.length) {
        console.log(hisArr)
        hisArr = hisArr.filter(app => {
          return app.fid !== item.fid
        })
        hisArr.unshift(item)
      } else {
        return
      }
      if (hisArr.length > 5) {
        hisArr.pop()
      }
      // if (hisArr.length) {
      //   this.$store.commit('SET_HISLIST', hisArr)
      // }
    }
  }
}
</script>
